import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/512c25b6/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import '@carbon/charts/styles.css';
import { SimpleBarChart, GroupedBarChart, StackedBarChart, PieChart, DonutChart, LineChart, ScatterChart } from '@carbon/charts-react';
import { addHeightToOptions // Bar
, groupedBarOptions, groupedBarData, groupedHorizontalBarOptions, groupedHorizontalBarData, simpleBarOptions, simpleBarData, simpleHorizontalBarOptions, simpleHorizontalBarData, simpleBarTimeSeriesOptions, simpleBarTimeSeriesData, simpleHorizontalBarTimeSeriesOptions, simpleHorizontalBarTimeSeriesData, stackedBarOptions, stackedBarData, stackedHorizontalBarOptions, stackedHorizontalBarData, stackedBarTimeSeriesOptions, stackedBarTimeSeriesData, stackedHorizontalBarTimeSeriesOptions, stackedHorizontalBarTimeSeriesData // Pie & donut
, pieOptions, pieData, donutOptions, donutData // Line
, lineTimeSeriesOptions, lineTimeSeriesData, lineData, lineOptions // Step
, stepOptions, stepData, stepTimeSeriesOptions, stepTimeSeriesData // Scatter
, scatterTimeSeriesOptions, scatterTimeSeriesData, scatterOptions, scatterData } from '../../../data/charts/index';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const InlineNotification = makeShortcode("InlineNotification");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Basic charts offer a way to visualize data sets in an intuitive, easy to understand way. Every chart should tell a story and should reflect the content on the page where it is found.`}</p>
    </PageDescription>



    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Bar chart</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Line chart</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Area chart</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Polar charts</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Scatter plots</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Meter and gauge</AnchorLink>
    </AnchorLinks>
    <h2>{`Bar chart`}</h2>
    <h3>{`Default`}</h3>
    <p>{`Bar charts use vertical or horizontal data markers to compare individual values. You can use them to compare discrete data or show trends over time.`}</p>
    <SimpleBarChart data={simpleBarData} options={addHeightToOptions(simpleBarOptions)} mdxType="SimpleBarChart" />
    <SimpleBarChart data={simpleBarTimeSeriesData} options={addHeightToOptions(simpleBarTimeSeriesOptions)} mdxType="SimpleBarChart" />
    <h3>{`Grouped bar chart`}</h3>
    <p>{`A grouped bar chart, also known as a clustered bar graph, multi-set bar chart, or grouped column chart, is a type of bar graph that is used to compare values across multiple categories.`}</p>
    <GroupedBarChart data={groupedBarData} options={addHeightToOptions(groupedBarOptions)} mdxType="GroupedBarChart" />
    <h3>{`Stacked bar`}</h3>
    <p>{`Stacked bar charts are useful for comparing proportional contributions within a category. They plot the relative value that each data series contributes to the total.`}</p>
    <StackedBarChart data={stackedBarData} options={addHeightToOptions(stackedBarOptions)} mdxType="StackedBarChart" />
    <StackedBarChart data={stackedBarTimeSeriesData} options={addHeightToOptions(stackedBarTimeSeriesOptions)} mdxType="StackedBarChart" />
    <h3>{`Horizontal bar`}</h3>
    <h3>{`Default`}</h3>
    <p>{`Bar charts use vertical or horizontal data markers to compare individual values. You can use them to compare discrete data or show trends over time.`}</p>
    <SimpleBarChart data={simpleHorizontalBarData} options={addHeightToOptions(simpleHorizontalBarOptions)} mdxType="SimpleBarChart" />
    <SimpleBarChart data={simpleHorizontalBarTimeSeriesData} options={addHeightToOptions(simpleHorizontalBarTimeSeriesOptions)} mdxType="SimpleBarChart" />
    <h3>{`Grouped bar chart`}</h3>
    <p>{`A grouped bar chart, also known as a clustered bar graph, multi-set bar chart, or grouped column chart, is a type of bar graph that is used to compare values across multiple categories.`}</p>
    <GroupedBarChart data={groupedHorizontalBarData} options={addHeightToOptions(groupedHorizontalBarOptions)} mdxType="GroupedBarChart" />
    <h3>{`Stacked bar`}</h3>
    <p>{`Stacked bar charts are useful for comparing proportional contributions within a category. They plot the relative value that each data series contributes to the total.`}</p>
    <StackedBarChart data={stackedHorizontalBarData} options={addHeightToOptions(stackedHorizontalBarOptions)} mdxType="StackedBarChart" />
    <StackedBarChart data={stackedHorizontalBarTimeSeriesData} options={addHeightToOptions(stackedHorizontalBarTimeSeriesOptions)} mdxType="StackedBarChart" />
    <h2>{`Line chart`}</h2>
    <h3>{`Default`}</h3>
    <p>{`Line charts plot data at regular intervals connected by lines. You can use line visualizations to show trends over time and compare several data sets.`}</p>
    <LineChart data={lineData} options={addHeightToOptions(lineOptions)} mdxType="LineChart" />
    <LineChart data={lineTimeSeriesData} options={addHeightToOptions(lineTimeSeriesOptions)} mdxType="LineChart" />
    <h3>{`Stepped line chart`}</h3>
    <p>{`Stepped line charts plot data at regular intervals, forming a series of steps between data points. You can use line visualizations to show trends over time and compare several data sets.`}</p>
    <LineChart data={stepData} options={addHeightToOptions(stepOptions)} mdxType="LineChart" />
    <h3>{`Curved line chart`}</h3>
    <LineChart data={lineTimeSeriesData} options={addHeightToOptions(lineTimeSeriesOptions)} mdxType="LineChart" />
    <h2>{`Area chart`}</h2>
    <h3>{`Default`}</h3>
    <p>{`Area charts are similar to line charts, but the areas below the lines are filled with colors or patterns. Stacked charts are useful for comparing proportional contributions within a category. They plot the relative value that each data series contributes to the total.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABu0lEQVQoz5WSXWsTURCG+1/10gsLtZhQLwTvRKiKtSqlqWgCjYgavRARL1TS1qRuUmuihUIblWQ/cppudhM3e/bx7Ec2Fq3BYYeZc2bOO+/OzEwQBPxLwvj/6Ez46Ej06OgGhtXFNE36jpsm/K0A4RdwIucE4HHXxTo6xug52LaN2esx8rxTWUg5BoqR/2AYiu/7U383BJAJI1eB1gwPPzmP7yNAIQSO40SVpZSJxn4EJuNkW3h82RJ8b9q8/tSnoPXZaA0VmbhYyjDsmztwTplKlKpaIGm8F+y+siiVTK4/0ll+onNTaVHddQ7dCUOra9Lt2IiDn1gqoLds2pZgX/9BdX+Pjb0mz15q5PMfyBV3uVpssaSA7j61WClZ3Fg3KNf7E8Dh0KHZaLO6pnFttcKF5TJzK2UuP95k8U2VK8qev/WW2TvvOLtU5sztTc7d22Y+95ns/abKbfCiasSAftKfytc2c2tbZAoamXyNzMMaFx/UubS+o851soUdssouqNhCoaZ8TcW3lf3IbK7C8+q3CcOwmd5olK7DeBjRVH0ZbcBgMFC+jx8OLFmddGi/vUkBp0kQyOk5Sn8BlZo1mPRkz4cAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Horizontal bar chart",
            "title": "Horizontal bar chart",
            "src": "/static/a60223545d1f2c4f1152bc303bd625a6/3cbba/charts-basic-area.png",
            "srcSet": ["/static/a60223545d1f2c4f1152bc303bd625a6/7fc1e/charts-basic-area.png 288w", "/static/a60223545d1f2c4f1152bc303bd625a6/a5df1/charts-basic-area.png 576w", "/static/a60223545d1f2c4f1152bc303bd625a6/3cbba/charts-basic-area.png 1152w", "/static/a60223545d1f2c4f1152bc303bd625a6/0b124/charts-basic-area.png 1728w", "/static/a60223545d1f2c4f1152bc303bd625a6/0c3f5/charts-basic-area.png 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h3>{`Stacked area chart`}</h3>
    <p>{`Stacked area charts are useful for comparing proportional contributions within a category. They plot the relative value that each data series contributes to the total.`}</p>
    <InlineNotification mdxType="InlineNotification">
      <p>{`Note: This chart is currently a work-in-progress. To see our roadmap, request missing guidance, or contribute content, please go to the carbon-charts `}<a parentName="p" {...{
          "href": "https://github.com/carbon-design-system/carbon-charts"
        }}>{`GitHub repository`}</a>{`.`}</p>
    </InlineNotification>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABo0lEQVQoz42SCW/aQBCF+f9/plLjtCgRUqIogA02BWLscKhSoEQBX/iCgO0va3O5aZp2pNmV9s28mZ03lSzL+Mxy/H89t0p+eO6Kl8WSpe1gWRZhFP0W9LcCH4B7Qt+JsT2f5SoiCHwsz2O33X7aSX6naUr6DqscyZMk+aOTcnCefLRXUey9pWnpy67jEsfxh18pv4XrNZ3xmGtNo/04ZLZcMhWjijabU2xBmM8tCIITyXSxYDSbsXDd09tczLcmiC7q91QVmctmA0mWkRp1aqqK7ftlUVwm0ykt00QxBlwoClKrzTeR0DJ0mvoDl417vqsaV/qIarfPdX/CzcCiZj7zVe1hPj2dCddxxPjXnC9NUbGjc/vgcDMKuZq4SL0x0o8BVf0ntaHPnbmm3gvoyD6DuxW9ZsBtN2Bkx3vC43xeFiFy36arBwwVD6PtoZkR6jBGM0K6RsRAWzGUbUayU/ijYjMWbjQc5s+bc4c56W67E1IL8nSvaJarmoh7l5BtE16jmFRsQoEdNiBJ0vMWCKwQJTsQFsQHPylcXoss5Z8mEt4AVMlHqaez7FUAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Horizontal bar chart",
            "title": "Horizontal bar chart",
            "src": "/static/d3f1651990763f57819ede9b541ce844/3cbba/charts-basic-areastacked.png",
            "srcSet": ["/static/d3f1651990763f57819ede9b541ce844/7fc1e/charts-basic-areastacked.png 288w", "/static/d3f1651990763f57819ede9b541ce844/a5df1/charts-basic-areastacked.png 576w", "/static/d3f1651990763f57819ede9b541ce844/3cbba/charts-basic-areastacked.png 1152w", "/static/d3f1651990763f57819ede9b541ce844/0b124/charts-basic-areastacked.png 1728w", "/static/d3f1651990763f57819ede9b541ce844/0c3f5/charts-basic-areastacked.png 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h2>{`Polar charts`}</h2>
    <h3>{`Pie`}</h3>
    <PieChart data={pieData} options={addHeightToOptions(pieOptions)} mdxType="PieChart" />
    <h3>{`Donut`}</h3>
    <DonutChart data={donutData} options={addHeightToOptions(donutOptions)} mdxType="DonutChart" />
    <h2>{`Scatter plots`}</h2>
    <h3>{`Default`}</h3>
    <p>{`Scatter plot visualizations use data points to plot two measures anywhere along a scale, not only at regular tick marks. You can use scatter plots to explore correlations between different measures.`}</p>
    <ScatterChart data={scatterData} options={addHeightToOptions(scatterOptions)} mdxType="ScatterChart" />
    <ScatterChart data={scatterTimeSeriesData} options={addHeightToOptions(scatterTimeSeriesOptions)} mdxType="ScatterChart" />
    <h3>{`Bubble chart`}</h3>
    <p>{`Bubble charts use data points and bubbles to plot measures anywhere along a scale. One measure is plotted along each axis. The size of the bubble represents the third measure. You can use bubble charts to represent financial data or any data where measured values are related.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} colMd={6} colSm={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.25%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAAsSAAALEgHS3X78AAABO0lEQVQoz41T226DMAzt/z/vG/Yj/YI9TNrjpEmdOsSlMJI4cXJmp0mBrusaZJyAfXx8DLuUEv5bGvOI6drpbehHNE2DbhjBMSIwg0JAkv1fBRcgoIbo+QzYGpyGAc1oYRxhNgbdNCEo6B02GaRea4YV/dbisGaZigFeimk3kVM2FNAMOM8zvPewnvBNtqSkC4OYRIbIcIbRSze5K8lRWWLYMs+Ak7QXhcn+9R1Pz3t8NITgJLk36I8W00wYnEPfBXwd7FZL3ABUzbywO3QWL2+dFCC0rcXnyeLYCmsbcrKV1lxM0qqyXtr8BajTZJlsXVHbXKmWn6leMRa9RVsx4rSJWQBloxNV8+QzuGrKHIrn5X05O4kjH2DF13eXKWtlItp6SVRfAcZxlGmeC9Xn1z4DPvKn3PusrmN+ALUTYx7T8jB9AAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Horizontal bar chart",
            "title": "Horizontal bar chart",
            "src": "/static/503adb59b01e85d623adcdb5f28bd60e/3cbba/charts-basic-bubble.png",
            "srcSet": ["/static/503adb59b01e85d623adcdb5f28bd60e/7fc1e/charts-basic-bubble.png 288w", "/static/503adb59b01e85d623adcdb5f28bd60e/a5df1/charts-basic-bubble.png 576w", "/static/503adb59b01e85d623adcdb5f28bd60e/3cbba/charts-basic-bubble.png 1152w", "/static/503adb59b01e85d623adcdb5f28bd60e/0b124/charts-basic-bubble.png 1728w", "/static/503adb59b01e85d623adcdb5f28bd60e/0c3f5/charts-basic-bubble.png 1856w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h2>{`Meter and gauge`}</h2>
    <InlineNotification mdxType="InlineNotification">
      <p><strong parentName="p">{`Note:`}</strong>{` Meter and gauge charts are not yet available in Carbon Charts. These explorations are subject to change.`}</p>
    </InlineNotification>
    <p>{`Meter and gauge charts are useful for showing values between a small number of variables either by using multiple markers on the same meter or gauge or by using multiples of the chart.`}</p>
    <Row mdxType="Row">
      <Column colMd={4} colLg={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAABXElEQVQ4y61T2U7DMBDs/78jwf/0jYciURBVLyClaQ47ceIcjWUPtgUlQWniFiytVtbao9nZ2Qn++UzaF6XUKf+Odt0ZcOiTC9hZhpxzBEGAJElAKYUQosP8YsCqqpCmKZgOzvNOfUyGXsD6eERME5QauCgr8KJ0lqEXcHcIML2fYbl5tfG+2zsPqgMobU3hgQK3C8AnDHmW2vaNlt9BCLGyOLcsdRZS2qwGYhTQsFNfLF2Os4ZqhNmQ0SfXGvjcu16GjDF4nmeHEUWRHYQxue/79t6IxohjlXEbih5IXdd2Q8w0RdOgLEvkeY4sz1qukG4MsyzDdrsFJTFiom2SpJ1Pa+ZhTpYnR4wCeiHF9HGN2cbH6u0DB73Xhq1pFZrUU7TELHjuZdlr7LkmdKcJ3LwAi7BAzZnWMbGxD0IUTO93I625LvChPOvHNpDCYMs/rRu2f96UNqBSuMrcn0OnKQUEMchbAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Meters",
            "title": "Meters",
            "src": "/static/b4a67b2a9fb9dee3c54756816a4054e9/a5df1/charts-basic-meter.png",
            "srcSet": ["/static/b4a67b2a9fb9dee3c54756816a4054e9/7fc1e/charts-basic-meter.png 288w", "/static/b4a67b2a9fb9dee3c54756816a4054e9/a5df1/charts-basic-meter.png 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
Meter charts can represent data with current value, minimum and maximum, and peaks or averages.
        </Caption>
      </Column>
      <Column colMd={4} colLg={4} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "576px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAABUUlEQVQ4y+VU2U7DMBDs/38KT7xzSFRIhTYEKrXQcrQqFKgQiePmcExqD84FJo6LkHhBrLSaxNrMHrNOB79snb9DKKX8wO9cj99aoS2oadvijAoJpfBIgDCKkDCmMC7e6TpEQNfFmd6JlVAIUeDl9AbdXh9nwxEuRhOMJ1P0nQFOHBc95xzXd3NjND9qOVN5HgMgTjcqQLTG6s9Gy0LkKAvsDiV2jiV2XWD5EoEGPjzfB+fcENJSYYmcK5I9wLmS2FQJasvJPM9DHMetpB2drCY82Admc2kk0i0nbVb6lbAaz4Oa+elRGcDYG0hAQcMQScLw6pNiC+pKCSGG4prKJbqHwGpRE3KMlerLp5XyZ8wW98X61OareWZZZmm5IrwdAAn9FIixFGnKkfLS9Y8jtatWwuasbLehTVnL2uji2O9127lV5ababUW2EVtb/h8/2HeGSCjiwJcl2QAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Gauge",
            "title": "Gauge",
            "src": "/static/f70f8aace897d77c6ab428db4aa2ac21/a5df1/charts-basic-gauge.png",
            "srcSet": ["/static/f70f8aace897d77c6ab428db4aa2ac21/7fc1e/charts-basic-gauge.png 288w", "/static/f70f8aace897d77c6ab428db4aa2ac21/a5df1/charts-basic-gauge.png 576w"],
            "sizes": "(max-width: 576px) 100vw, 576px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
        <Caption mdxType="Caption">
  Gauge animates to the current value when dashboard loads to create emphasis.
        </Caption>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      